import { render, staticRenderFns } from "./MessagePayment.vue?vue&type=template&id=937435d2"
import script from "./MessagePayment.vue?vue&type=script&lang=js"
export * from "./MessagePayment.vue?vue&type=script&lang=js"
import style0 from "./MessagePayment.vue?vue&type=style&index=0&id=937435d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports